<div class="modal-header">
  <i class="fa fa-close" (click)="close()" style="float:right;"></i>
  <h2>Select a program</h2>
</div>
<div class="modal-body">
  <div class="row text-center" style="justify-content: space-around;">
          <button *ngIf="(PreCERCLIS.item | isEmpty) && (PreCERCLIS.meta.permissions && PreCERCLIS.meta.permissions.write)"
                  class="btn btn-default" style="width:111px; margin:0 10px 10px 10px;" (click)="open(PreCERCLIS)"><i
              class="fa fa-leaf fa-2x"></i><br/> Pre-CERCLIS
          </button>
          <button *ngIf="(SolidWaste.item | isEmpty) && SolidWaste.meta.permissions && SolidWaste.meta.permissions.write"
                  class="btn btn-default" style="width:111px; margin:0 10px 10px 10px;" (click)="open(SolidWaste)"><i
              class="fa fa-trash-o fa-2x"></i><br/> Solid Waste
          </button>

          <button *ngIf="(TierII.item | isEmpty) && TierII.meta.permissions && TierII.meta.permissions.write"
                  class="btn btn-default" style="width:111px; margin:0 10px 10px 10px;" (click)="open(TierII)"><i
              class="fa fa-industry fa-2x"></i><br/> Tier II
          </button>

    <button *ngIf="Beaches.meta.permissions?.write && (Beaches.item | isEmpty)"
            class="btn btn-default" style="width:111px; margin:0 10px 10px 10px;" (click)="open(Beaches)"><i
      class="fa fa-tint fa-2x"></i><br/> Beaches
    </button>
          <button *ngIf="(FUDS.item | isEmpty) && FUDS.meta.permissions && FUDS.meta.permissions.write"
                  class="btn btn-default" style="width:111px; margin:0 10px 10px 10px;" (click)="open(FUDS)"><i
              class="fa fa-bomb fa-2x"></i><br/> FUDS
          </button>
          <button *ngIf="(Brownfields.item | isEmpty) && Brownfields.meta.permissions && Brownfields.meta.permissions.write"
                  class="btn btn-default" style="width:111px; margin:0 10px 10px 10px;" (click)="open(Brownfields)">
            <i class="fa fa-recycle fa-2x"></i><br/> Brownfields
          </button>
          <button *ngIf="(StandbyGenerators.item | isEmpty) && StandbyGenerators.meta.permissions && StandbyGenerators.meta.permissions.write"
                  class="btn btn-default" style="width:111px; margin:0 10px 10px 10px;"
                  (click)="open(StandbyGenerators)">
            <div><i class="fa fa-bolt fa-2x"></i></div>
            <div style="float: right;">Standby <br/>Generators</div>
          </button>
          <button *ngIf="(UST.item | isEmpty) && UST.meta.permissions && UST.meta.permissions.write"
                  class="btn btn-default" style="width:111px; margin:0 10px 10px 10px;" (click)="open(UST)"><i
              class="fa fa-flask fa-2x"></i><br/>Storage Tanks
          </button>
          <button *ngIf="(Pesticides.item | isEmpty) && Pesticides.meta.permissions && Pesticides.meta.permissions.write"
                        class="btn btn-default" style="width:111px; margin:0 10px 10px 10px;" (click)="open(Pesticides)"><i
                        class="fa fa-bug fa-2x"></i><br/>Pesticides
          </button>
          <button *ngIf="OneStop.meta.permissions?.write && !OneStop.item.globalid"
                  class="btn btn-default" style="width:111px; margin:0 10px 10px 10px;" (click)="open(OneStop)"><i
              class="fa fa-building fa-2x"></i><br/>One Stop
          </button>
          <button *ngIf="(ER.item | isEmpty) && ER.meta.permissions && ER.meta.permissions.write"
                  class="btn btn-default" style="width:111px; margin:0 10px 10px 10px;" (click)="open(ER)"><i
              class="fa fa-building fa-2x"></i><br/>Emergency<br/>Response
          </button>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-default" (click)="close()">Close</button>
</div>
